module.exports = __webpack_public_path__ + "static/img/MZ.64850e0b.svg";